
	import Vue from "vue"
	import { Prop } from "vue-property-decorator"
	import Component from "vue-class-component"

	import PTextInput from "@portal-components/ui/input/PTextInput.vue"

	import { Address } from "store/company/types"

	@Component({
		components: {
			PTextInput
		}
	})
	export default class CompanyAddressForm extends Vue {
		@Prop({ type: Object, required: true }) model!: Address

		readonly baseTranslationKey = "profile.companyAddress"
	}
